const storageKey = (farmId) => `service-order-machine-groups-${farmId}`;
const visibleStorageKey = (farmId) =>
  `service-order-visible-machines-${farmId}`;

export function loadServiceOrderMachineGroups(farmId) {
  if (!farmId) return [];
  try {
    const raw = localStorage.getItem(storageKey(farmId));
    const parsed = raw ? JSON.parse(raw) : [];
    return Array.isArray(parsed) ? parsed : [];
  } catch (_) {
    return [];
  }
}

export function saveServiceOrderMachineGroups(farmId, groups) {
  if (!farmId) return;
  localStorage.setItem(storageKey(farmId), JSON.stringify(groups || []));
}

export function createMachineGroupId() {
  return `group-${Date.now()}-${Math.random().toString(36).slice(2, 7)}`;
}

export function loadVisibleServiceOrderMachines(farmId) {
  if (!farmId) return null;
  try {
    const raw = localStorage.getItem(visibleStorageKey(farmId));
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed.map(String) : null;
  } catch (_) {
    return null;
  }
}

export function saveVisibleServiceOrderMachines(farmId, machineIdents) {
  if (!farmId) return;
  if (!Array.isArray(machineIdents)) {
    localStorage.removeItem(visibleStorageKey(farmId));
    return;
  }
  localStorage.setItem(
    visibleStorageKey(farmId),
    JSON.stringify(machineIdents.map(String))
  );
}

export function nextVisibleMachineIdents(allIdents, visibleIdents, toggledId) {
  const all = (allIdents || []).map((ident) => String(ident || "").trim()).filter(Boolean);
  const current = Array.isArray(visibleIdents) ? visibleIdents.map(String) : all.slice();
  let next;
  if (toggledId === "*") {
    const allOn = all.length > 0 && all.every((ident) => current.includes(ident));
    next = allOn ? [] : all.slice();
  } else {
    const ident = String(toggledId || "").trim();
    next = current.includes(ident)
      ? current.filter((item) => item !== ident)
      : current.concat(ident);
  }
  if (all.length > 0 && all.every((ident) => next.includes(ident))) return null;
  return next;
}

export function machinesInVisibleGroup(machines, visibleIdents) {
  const list = machines || [];
  if (!Array.isArray(visibleIdents)) return list;
  const allowed = new Set(
    visibleIdents.map((ident) => String(ident || "").trim().toLowerCase())
  );
  return list.filter((machine) =>
    allowed.has(String((machine && machine.ident) || "").trim().toLowerCase())
  );
}
